import AccountContent from './AccountContent';
import { connect } from 'react-redux';
import { accountViewMenuOptionSel } from 'src/store/modules/accountview';

const mapStateToProps = (state: any) => {
  return {
    selected: accountViewMenuOptionSel(state)
  };
};

export const pureComponent = AccountContent;
export default connect(mapStateToProps, null)(AccountContent);
